export interface RateResponseModel {
    likes: number;
    dislikes: number;
    liked?: boolean | null;
}
